<template>
  <div class="flex flex-1 flex-col">
    <vx-card class="vx-card_full-height">
      <div class="vx-row items-center justify-between flex-wrap flex-shrink-0">
        <div class="vx-col w-auto flex flex items-center flex-wrap">
          <h4 class="whitespace-no-wrap">Начисления</h4>
          <div class="w-auto flex flex-wrap items-center ml-2">
            <div class="mr-2 mb-2">
              <label class="vs-input--label pl-1">Период с:</label>
              <datepicker
                v-model="date_from"
                class="datepicker_small"
                format="MMMM yyyy"
                :minimumView="'month'"
                :maximumView="'year'"
                :disabledDates="disabledDatesFrom"
              />
            </div>
            <div class="mr-2 mb-2">
              <label class="vs-input--label pl-1">По:</label>
              <datepicker
                class="datepicker_small"
                v-model="date_to"
                format="MMMM yyyy"
                :minimumView="'month'"
                :maximumView="'year'"
                :disabledDates="disabledDatesTo"
              />
            </div>
            <div class="mb-2 mr-2">
              <elsa-v-select
                :options="apartmentFilterOptions"
                v-model="selectedApartmentsType"
                label="name"
                :reduce="item => item.id"
                :clearable="false"
                :disabled="apartmentsTypes.length <= 1"
                htmlLabel="Тип помещения"
                styleType="small"
              />
            </div>

            <!--            <div class="mb-2 self-stretch flex flex-col pt-1">-->
            <!--              <label class="vs-select&#45;&#45;label mr-2 block mb-2">Только перерасчеты</label>-->
            <!--              <vs-switch class="ml-2" v-model="showOnlyRecalculation" ref="toggleShowInactiveDevices" />-->
            <!--            </div>-->
          </div>
        </div>

        <div class="vx-col w-auto flex items-center flex-shrink-0 md:flex-no-wrap flex-wrap">
          <vs-button
            type="border" v-if="$can('rp.charges', 'write')" @click="isStartComputationOpen = true"
            class="mr-2 whitespace-no-wrap"
          >Расчет начислений
          </vs-button>
          <vs-button
            type="border" v-if="$can('rp.charges', 'access')" @click="openHistoryPopup"
            class="mr-2 whitespace-no-wrap" iconPack="feather" icon="icon-clock" title="История"
          />
          <vs-button
            type="border" @click="exportTable()" class="mr-2 whitespace-no-wrap" iconPack="feather"
            icon="icon-download" title="Экспортировать в CSV"
          />
          <vs-button
            type="border" v-if="$can('rp.charges', 'write')" color="danger"
            @click="isDeleteAccrualsPopupOpen = true" iconPack="feather" icon="icon-trash"
            title="Удалить начисления"
          />
        </div>
      </div>

      <div class="flex flex-1 flex-col pt-6">
        <grid-infinite-scroll
          ref="table"
          :columns="columns"
          :getData="getData"
          :maxConcurrentDatasourceRequests="4"
          :pinnedRowsGetters="pinnedRowsGetters"
          :getPinnedRows="getPinnedRows"
          :filterable="false"
          :sortable="false"
          noRowsText="Начисления не найдены"
        />
      </div>

    </vx-card>

    <start-computation-popup
      :active.sync="isStartComputationOpen"
      :buildingsId="selectedHouseId"
      :showMonth="true"
      @startComputation="startComputation"
      showApartmentsTypes
    />

    <vs-popup :active.sync="isDeleteAccrualsPopupOpen" title="Удаление начислений" class="delete-accruals-popup">
      <div class="vx-row justify-center">
        <div class="mb-4">
          <label class="vs-input--label pl-1">Месяц:</label>
          <datepicker
            v-model="selectedDate"
            format="MMMM yyyy"
            :minimumView="'month'"
            :maximumView="'year'"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full flex justify-center">
          <vs-button type="border" color="danger" class="mb-2" @click="deleteAccruals">Удалить</vs-button>
        </div>
      </div>
    </vs-popup>

    <history-popup ref="historyPopup" :buildings-id="selectedHouseId" />

    <calculation-result :active.sync="isCalculationResultOpen" :info="calculationResult" />
  </div>
</template>

<script>
import StartComputationPopup from "@/components/calculated-program/accruals/StartComputationPopup";
import CalculationResult     from "@/components/calculated-program/accruals/CalculationResult";
import AccountNumberRenderer from "@/components/employee/accounts/AccountNumberRenderer";
import AccrualsSumRenderer   from "@/components/employee/accruals/AccrualsSumRenderer";
import HistoryPopup          from "@/components/calculated-program/accruals/HistoryPopup";
import notifyHttpError       from "@/mixins/notifyHttpError";

export default {
  name:       "Accruals",
  components: {
    StartComputationPopup,
    CalculationResult,
    HistoryPopup,
  },
  mixins:     [notifyHttpError],
  data() {
    return {
      date_from: (new Date()).setMonth((new Date()).getMonth() - 3), // now - 3 month
      date_to:   Date.now(),

      columns:           [
        {
          headerName:            'Счет',
          field:                 'charges.account_number',
          minWidth:              80,
          sortable:              true,
          filter:                true,
          pinned:                'left',
          withLoading:           true,
          cellRendererFramework: AccountNumberRenderer,
          cellRendererParams:    ( { data } ) => data,
          valueGetter:           ( { data } ) => data.account_number,
        },
        {
          headerName:  'Помещение',
          field:       'a.number',
          maxWidth:    120,
          minWidth:    80,
          flex:        2,
          filter:      false,
          sortable:    false,
          pinned:      'left',
          valueGetter: ( { data } ) => data.number || '',
        },
        {
          headerName:  'Тариф',
          field:       'tarifs.name',
          minWidth:    200,
          flex:        2,
          filter:      false,
          sortable:    false,
          valueGetter: ( { data } ) => data.tarifs_name || '',
        },
        {
          headerName:   'Месяц',
          field:        'charges.month',
          filter:       'date',
          minWidth:     120,
          filterParams: {
            minimumView: 'month',
            showFormat:  'MMMM yyyy',
            sendFormat:  'YYYY-MM',
          },
          valueGetter:  ( { data } ) => {
            return data.month ? this.$options.filters.moment(this.$parseDateFromString(data.month), 'MMMM YYYY') : '';
          },
        },
        {
          headerName:  'Объем услуг',
          field:       'consumption',
          filter:      'number',
          minWidth:    100,
          valueGetter: ( cell ) => {
            if (cell.node.rowPinned) {
              return '';
            }
            return cell.data.consumption !== null ? cell.data.consumption : '-';
          },
        },
        {
          headerName:            'Сумма начисления',
          field:                 'charges.sum',
          filter:                "number",
          minWidth:              140,
          cellRendererFramework: AccrualsSumRenderer,
          cellRendererParams:    ( { data } ) => Object.assign({}, data, {
            onClick: ( id ) => {
              this.getChargeCalculation(id);
            },
          }),
          valueGetter:           ( { data } ) => data.sum ? this.$options.filters.numberWithSpaces(Number(data.sum)) : 0,
        },
        {
          headerName:   'Перерасчет',
          field:        'charges.recalculation',
          filter:       false,
          sortable:     false,
          minWidth:     100,
          valueGetter:  ( { data } ) => !!data.recalculation,
          cellRenderer: ( data ) => {
            if (data.node.rowPinned) {
              return '';
            }

            return `${data.value ? 'Да' : 'Нет'}`;
          },
        },
        {
          headerName:  'Автор',
          field:       'users.name',
          filter:      false,
          minWidth:    160,
          valueGetter: ( { data, node } ) => {
            if (node.rowPinned) {
              return '';
            }
            return data.users_name || 'Неизвестно';
          },
          // cellRenderer: ({value}) => {
          //   return `<span style="white-space: nowrap">${value}</span>`;
          // }
        },
      ],
      pinnedRowsGetters: {
        'charges.account_number': 'Всего',
        'charges.sum':            ( { 'charges.sum': sum } ) => {
          return sum === null ? '-' : this.$options.filters.numberWithSpaces(sum);
        },
      },

      accrualsHistory:           [],
      historyInterval:           null,
      isStartComputationOpen:    false,
      pinnedRows:                [],
      exportRows:                [],
      selectedApartmentsType:    null,
      isDeleteAccrualsPopupOpen: false,
      isAccrualsErrorsOpen:      false,
      accrualErrors:             [],
      isCalculationResultOpen:   false,
      calculationResult:         {},
      constants:                 [],
      showOnlyRecalculation:     false,
    };
  },
  computed: {
    apartmentsTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },
    disabledDatesFrom() {
      return {
        from: new Date(this.date_to),
      };
    },
    disabledDatesTo() {
      return {
        to: new Date(this.date_from),
      };
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
    selectedDate: {
      get() {
        return this.$store.getters['appUser/selectedDate'];
      },
      set( value ) {
        this.$store.dispatch('appUser/SET_DATE', value);
      },
    },
    apartmentFilterOptions() {
      return [{ id: null, name: 'Все' }].concat(this.apartmentsTypes);
    },
  },
  methods:  {
    openHistoryPopup() {
      this.$refs.historyPopup.open();
    },
    closeHistoryPopup() {
      this.$refs.historyPopup.close();
    },
    openAccrualsErrors( errors ) {
      this.accrualErrors = errors;
      this.isAccrualsErrorsOpen = true;
    },
    async getChargeCalculation( id ) {
      try {
        let { data } = await this.$http.get('charge_calculation', {
          params: {
            id:           id,
            buildings_id: this.selectedHouseId,
          },
        });
        this.calculationResult = data;
        this.isCalculationResultOpen = true;
      } catch {
        this.calculationResult = {};
      }
    },

    resetData() {
      this.$refs.table && this.$refs.table.resetData();
    },
    getData( page, filters, orderBy ) {
      return new Promise(async ( resolve ) => {
        let { data } = await this.$http.get('charge', {
          params: {
            orderby:         orderBy,
            filters:         filters,
            page:            page,
            buildings_id:    this.selectedHouseId,
            from:            this.$options.filters.formatDate(this.date_from),
            to:              this.$options.filters.formatDate(this.date_to),
            apartments_type: this.selectedApartmentsType === null ? undefined : this.selectedApartmentsType,
          },
        });
        resolve({
          response: data,
          total:    data.total,
          data:     data.data,
        });
      });
    },
    getPinnedRows( filters, orderBy ) {
      return new Promise(async ( resolve ) => {
        let { data } = await this.$http.get('charge_sums', {
          params: {
            orderby:         orderBy,
            filters:         filters,
            buildings_id:    this.selectedHouseId,
            from:            this.$options.filters.formatDate(this.date_from),
            to:              this.$options.filters.formatDate(this.date_to),
            apartments_type: this.selectedApartmentsType === null ? undefined : this.selectedApartmentsType,
          },
        });

        resolve([{ 'charges.sum': data ? Number(data) : null }]);
      });
    },
    async exportTable() {
      this.$refs.table.exportRows('Начисления');
    },

    async startComputation( params ) {
      let start = async () => {
        try {
          this.openHistoryPopup();
          params.buildings_id = this.selectedHouseId;
          await this.$http.get('create_charge', { params });
          this.$vs.notify({ color: 'success', title: 'Расчет начался', text: 'Ожидайте завершения' });
          this.resetData();
        } catch (e) {
          this.notifyHttpError(e);
        }
      };

      if (this.accrualsHistory.length >= 1 && this.accrualsHistory[0].status !== 1) {
        this.$vs.dialog({
          type:       'confirm',
          color:      'primary',
          title:      'Подтверждение',
          text:       'Вы уверены что хотите начать расчет начислений, предыдущий расчет еще не закончен?',
          acceptText: 'Да',
          cancelText: 'Отменить',
          accept:     () => start(),
        });
      } else {
        start();
      }
    },
    updateSelectedApartmentsType() {
      if (this.apartmentsTypes.length === 1) {
        this.selectedApartmentsType = this.apartmentsTypes[0].id;
      } else if (this.apartmentsTypes.length > 1) {
        this.selectedApartmentsType = null;
      }
    },
    deleteAccruals() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       `Вы уверены что хотите удалить начисления за ${this.$options.filters.moment(this.selectedDate, 'MMMM YYYY')}`,
        acceptText: 'Да',
        cancelText: 'Нет',
        accept:     async () => {
          try {
            let body = {
              buildings_id: this.selectedHouseId,
              month:        this.$options.filters.formatDate(this.selectedDate),
            };
            if (this.selectedApartmentsType !== null) {
              body.apartments_type = this.selectedApartmentsType;
            }

            let { data } = await this.$http.delete('charge', { params: body });
            if (data === "denied") {
              this.$vs.notify({
                color: 'danger',
                title: 'Ошибка удаления',
                text:  'Квитанции на данный месяц уже показаны',
              });
            } else if (data === "error") {
              this.$vs.notify({ color: 'danger', title: 'Ошибка удаления', text: 'Произошла ошибка' });
            } else {
              this.$vs.notify({ color: 'success', title: 'Успешное удаление', text: 'Начисления удалены' });
            }

            this.isDeleteAccrualsPopupOpen = false;
            this.resetData();

          } catch (e) {
            if (e.response) {
              if (e.response.status === 403) {
                this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
              } else {
                this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
              }
            } else {
              this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
            }
          }

        },
      });
    },
  },
  watch:    {
    apartmentsTypes() {
      this.updateSelectedApartmentsType();
    },
    selectedHouseId() {
      this.resetData();
    },
    date_from() {
      this.resetData();
    },
    date_to() {
      this.resetData();
    },
    selectedApartmentsType() {
      this.resetData();
    },
  },
  async mounted() {
    this.updateSelectedApartmentsType();
  },
};
</script>

<style lang="scss">
.accrualsHistoryPopup {
  .vs-popup {
    width: 1100px;
  }
}

.delete-accruals-popup {
  .vs-popup {
    width: 380px;
  }
}
</style>
